module.exports = __webpack_public_path__ + "img/retired-2013-cuandixia.ccaf0f27.jpg";